import styled from 'styled-components/macro';

export const SeparatorLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: #e6e6e5;
  margin: 2.5rem 0;
`;
